import { getField, updateField } from 'vuex-map-fields';

const definition = {
	namespaced: true,
	state: {
		definition: null,
		proposed_uses: null,
		description: null,
		explain_preferred_definition: null
	},
	getters: {
		getField,
		getDefinition(state){
			return state.definition;
		}
	},
	mutations: {
		updateField,
		setDefinition(state, value){
			state.definition = value;
		}
	}
}

const vision = {
	namespaced: true,
	state: {
		vision: null,
		description: null
	},
	getters: {
		getField,
		getVision(state){
			return state.vision;
		}
	},
	mutations: {
		updateField,
		setVision(state, value){
			state.vision = value;
		}
	}
}

const system_components = {
	namespaced: true,
	state: {
		components: [],
		description: null
	},
	getters: {
		getField,
		getComponents(state){
			return state.components;
		}
	},
	mutations: {
		updateField,
		setComponents(state, value){
			state.components = value;
		}
	}
}

const public_access = {
	namespaced: true,
	state: {
		access: null,
		description: null,
		schedule: null,
		event_description: null,
		improvements: [
			{
				type: 'Unpaved small parking area',
				included: false,
				area: null
			},
			{
				type: 'Unpaved roads',
				included: false,
				area: null,
				length: null
			},
			{
				type: 'Unpaved trails',
				included: false,
				area: null,
				length: null
			},
			{
				type: 'Boardwalks',
				included: false,
				area: null,
				length: null
			},
			{
				type: 'Footbridges',
				included: false,
				area: null,
				length: null
			},
		],
		are_other_improvements: null,
		other_improvements: null
	},
	getters: {
		getField,
		getAccess(state){
			return state.access;
		}
	},
	mutations: {
		updateField,
		setAccess(state, value){
			state.access = value;
		}
	}
}

const protection_wildlife = {
	namespaced: true,
	state: {
		protection: null,
		species_saved: null,
		describe_preservation: null
	},
	getters: {
		getField,
		getProtection(state){
			return state.protection;
		}
	},
	mutations: {
		updateField,
		setProtection(state, value){
			state.protection = value;
		}
	}
}

const protection_natural_resources = {
	namespaced: true,
	state: {
		protections: [],
		description: null
	},
	getters: {
		getField,
		getProtections(state){
			return state.protections;
		}
	},
	mutations: {
		updateField,
		setProtections(state, value){
			state.protections = value;
		}
	}
}

const history_culture = {
	namespaced: true,
	state: {
		features: null,
		description: null,
		detail_preservation: null,
		education: null
	},
	getters: {
		getField,
		getFeatures(state){
			return state.features;
		}
	},
	mutations: {
		updateField,
		setFeatures(state, value){
			state.features = value;
		}
	}
}

const threat_of_loss = {
	namespaced: true,
	state: {
		threat: null,
		description: null
	},
	getters: {
		getField,
		getThreat(state){
			return state.threat;
		}
	},
	mutations: {
		updateField,
		setThreat(state, value){
			state.threat = value;
		}
	}
}

const consistent_adopted_plans = {
	namespaced: true,
	state: {
		plans: [],
		other_plan: null,
		description: null,
		planning_entity_support: null
	},
	getters: {
		getField,
		getPlans(state){
			return state.plans;
		}
	},
	mutations: {
		updateField,
		setPlans(state, value){
			state.plans = value;
		}
	}
}

const acquisition_ready = {
	namespaced: true,
	state: {
		readiness: null,
		projected_timeline: null,
		over_six_month_description: null
	},
	getters: {
		getField,
		getReadiness(state){
			return state.readiness;
		}
	},
	mutations: {
		updateField,
		setReadiness(state, value){
			state.readiness = value;
		}
	}
}

const public_ready = {
	namespaced: true,
	state: {
		readiness: null,
		projected_timeline: null,
		phase_completion_dates: null,
		immediate_use: null
	},
	getters: {
		getField,
		getReadiness(state){
			return state.readiness;
		}
	},
	mutations: {
		updateField,
		setReadiness(state, value){
			state.readiness = value;
		}
	}
}

const public_support = {
	namespaced: true,
	state: {
		is_public_support: null,
		support: [],
		description: null
	},
	getters: {
		getField,
		getSupport(state){
			return state.support;
		}
	},
	mutations: {
		updateField,
		setSupport(state, value){
			state.support = value;
		}
	}
}

const funding_leveraging = {
	namespaced: true,
	state: {
		funding: null
	},
	getters: {
		getField,
		getFunding(state){
			return state.funding;
		}
	},
	mutations: {
		updateField,
		setFunding(state, value){
			state.funding = value;
		}
	}
}

const project_management = {
	namespaced: true,
	state: {
		management: [],
		maintenance_staff_description: null,
		funding_security: null,
		financial_staff_description: null
	},
	getters: {
		getField,
		getManagement(state){
			return state.management;
		}
	},
	mutations: {
		updateField,
		setManagement(state, value){
			state.management = value;
		}
	}
}

const partnership_coordination = {
	namespaced: true,
	state: {
		partner_list: null,
		partner_roles: null,
		greenspace_conservation: null,
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

const return_investment = {
	namespaced: true,
	state: {
		investment_returns: [],
		other_description: null,
		description: null
	},
	getters: {
		getField,
		getInvestmentReturns(state){
			return state.investment_returns;
		}
	},
	mutations: {
		updateField,
		setInvestmentReturns(state, value){
			state.investment_returns = value;
		}
	}
}

const additional_information = {
	namespaced: true,
	state: {
		information: null
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

const limits = {
	namespaced: true,
	state: {
		easement_draft: null,
		draft_restrictions: null
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

export const criteria = {
	namespaced: true,
	modules: {
		definition,
		vision,
		system_components,
		public_access,
		protection_wildlife,
		protection_natural_resources,
		history_culture,
		threat_of_loss,
		consistent_adopted_plans,
		acquisition_ready,
		public_ready,
		public_support,
		funding_leveraging,
		project_management,
		partnership_coordination,
		return_investment,
		limits,
		additional_information
	}
}
